let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eRZGo")).then(() => parcelRequire('9wf6u'));